import type { InstagramAudioSelection } from 'types/Attachments';
import type { InstagramAudioTrack } from '../types';

export function formatTrackSubtitle(
  track: Pick<
    InstagramAudioTrack | InstagramAudioSelection,
    'display_artist' | 'ig_username'
  >,
): string | null {
  const parts = [
    track.display_artist,
    track.ig_username ? `@${track.ig_username}` : null,
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(' · ') : null;
}
